export default __webpack_public_path__ + "static/media/solid.26da3d82.png";